import Vue from 'vue';
import { isEqual } from 'lodash';
import * as types from './mutation-types';
import { compileAsyncMutations } from '@/utils/async';


const mutations = {

  /** If the issues is fetching set as true also set as false */
  [types.GET_JIRA_ISSUES_LOADING](state, payload) {
    const isLoading = payload.loading === true;
    Vue.set(state.issues, 'issuesLoading', isLoading);
  },

  /** Put all issues in the state as object properties */
  [types.GET_JIRA_ISSUES](state, payload) {
    if (payload.issuesFormatted.length) {
      payload.issuesFormatted.forEach((issue) => {
        Vue.set(state.issues.data, issue.id, issue);
      });
    }
  },

  /** If the issue is fetching set as true also set as false */
  [types.GET_JIRA_ISSUE_LOADING](state, payload) {
    const isLoading = payload.loading === true;
    // Check if the issue exist
    if (state.issues.data[`${payload.issueId}`]) {
      Vue.set(state.issues.data[`${payload.issueId}`], 'issueLoading', isLoading);
    }
  },

  /** Check if the issue exist / is different and put it
   * in the state if necessary
   */
  [types.GET_JIRA_ISSUE](state, payload) {
    if (state.issues.data[`${payload.issueId}`]) {
      // The issue already exist
      if (!isEqual(state.issues.data[`${payload.issueId}`].statusId, payload.data.statusId)) {
        // The current issue stored in the state don't have the last update about the status
        state.issues.data[`${payload.issueId}`].statusId = payload.data.statusId;
      }
    } else {
      // The issue do not exist
      Vue.set(state.issues.data, payload.issueId, payload.data);
    }
  },

  /** If attachments is fetching set as true also set as false */
  [types.GET_JIRA_ISSUE_ATTACHMENTS_LOADING](state, payload) {
    const isLoading = payload.loading === true;
    if (state.issues.data[`${payload.issueId}`]) {
      Vue.set(state.issues.data[`${payload.issueId}`], 'attachmentsLoading', isLoading);
    }
  },

  /** Store attachments if the issue exist */
  [types.GET_JIRA_ISSUE_ATTACHMENTS](state, payload) {
    if (state.issues.data[`${payload.issueId}`]) {
      Vue.set(state.issues.data[`${payload.issueId}`], 'attachments', payload.data);
    }
  },

  /** If comments is fetching set as true also set as false */
  [types.GET_JIRA_ISSUE_COMMENTS_LOADING](state, payload) {
    const isLoading = payload.loading === true;
    if (state.issues.data[`${payload.issueId}`]) {
      Vue.set(state.issues.data[`${payload.issueId}`], 'commentsLoading', isLoading);
    }
  },

  /** Store comments if the issue exist */
  [types.GET_JIRA_ISSUE_COMMENTS](state, payload) {
    if (state.issues.data[`${payload.issueId}`]) {
      Vue.set(state.issues.data[`${payload.issueId}`], 'comments', payload.data);
    }
  },
};

// For each async mutations, dynamically add three mutations
// See @/utils/async for more details
compileAsyncMutations(mutations, types);

export default mutations;
